<template>
  <div class="mt-20">
    <div
      class="card card-custom gutter-b px-4 py-8 mx-auto my-5"
      style="max-width: 76.923rem"
    >
      <h2 class="soha-company-name">{{ companyName }}</h2>
    </div>
    <div
      id="secondcv"
      :data-company="$route.query.companyId"
      :data-job="$route.query.job"
      data-page-reload="true"
    />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import UIMixin from "@/mixins/UIMixin";

export default {
  name: "JobOpportunity",

  mixins: [UIMixin],

  data() {
    return {
      companyName: null,
    };
  },

  mounted() {
    let script = document.createElement("script");
    script.setAttribute(
      "src",
      "/js/import-resume-register-in-employer-site.js"
    );
    document.body.appendChild(script);
    this.getCompany();
  },
  methods: {
    getCompany() {
      ApiService.post("api/jobSeeker/showCompanyInfo", {
        id: this.$route.query.companyId,
      }).then((response) => {
        if (response.data.status === "noAccess") {
          setTimeout(() => {
            this.errorToast("شما به این قسمت دسترسی ندارید");
          }, 100);
        } else {
          this.companyName = response.data.name;
        }
      });
    },
  },
};
</script>

<style>
.soha-company-name {
  font-weight: bold;
  color: var(--primary-color);
  margin: auto;
}
.soha-login-box {
  background-color: white !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  margin: 0 !important;
  z-index: 1;
}

.soha-jobseeker-login {
  display: block !important;
}
.soha-jobseeker-import-resume {
  display: none;
}
</style>
